import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, MenuItem } from '@mui/material';
import Grid from '@mui/system/Unstable_Grid';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
const DialogInteracao = ({ tecnicos, onClose, ...props }) => {
    const formik = useFormik({
        initialValues: {
            tipoId: undefined,
            data: undefined,
            tecnicoId: undefined
        },
        validationSchema: yup.object({
            tipoId: yup.number().required('O campo é obrigatório'),
            data: yup.date().typeError('Data/hora inválida').required('O campo é obrigatório'),
            tecnicoId: yup.number().required('O campo é obrigatório')
        }),
        validateOnMount: false,
        onSubmit: async (values) => {
            onClose(values);
        }
    });
    return (<Dialog {...props}>
      <form>
        <DialogTitle>Adicionar interação</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid lg={4} md={12} xs={12}>
              <TextField label='Tipo de agendamento' name='tipoId' value={formik.values?.tipoId} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth required error={formik.touched.tipoId && Boolean(formik.errors.tipoId)} helperText={formik.touched.tipoId && formik.errors.tipoId} select>
                <MenuItem value={undefined} disabled></MenuItem>
                {[
            {
                id: 2,
                name: 'Orçamento'
            },
            {
                id: 3,
                name: 'Visita técnica'
            }
        ].map(x => (<MenuItem value={x.id} key={x.id}>
                    {x.name}
                  </MenuItem>))}
              </TextField>
            </Grid>
            <Grid lg={4} md={4} xs={12}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DateTimePicker label='Data/Hora' format='DD/MM/YYYY HH:mm' value={formik.values?.data} onChange={value => {
            formik.setFieldValue('data', value, true);
        }} slotProps={{
            textField: {
                variant: 'outlined',
                name: 'data',
                onBlur: formik.handleBlur,
                error: formik.touched.data && Boolean(formik.errors.data),
                fullWidth: true,
                helperText: formik.touched.data && Boolean(formik.errors.data) && String(formik.errors.data) // Use boolean cause string([]) = "undefined"
            }
        }}/>
              </LocalizationProvider>
            </Grid>
            <Grid lg={4} md={8} xs={12}>
              <TextField label='Técnico' name='tecnicoId' value={formik.values?.tecnicoId} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.tecnicoId && Boolean(formik.errors.tecnicoId)} helperText={formik.touched.tecnicoId && formik.errors.tecnicoId} select>
                <MenuItem value={undefined} disabled></MenuItem>
                {tecnicos &&
            tecnicos.map(x => (<MenuItem value={x.id} key={x.id}>
                      {x.name}
                    </MenuItem>))}
              </TextField>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button type='button' onClick={() => onClose(undefined)}>
            Cancelar
          </Button>
          <Button onClick={() => {
            formik.handleSubmit();
        }} disabled={!formik.isValid || !formik.dirty || formik.isSubmitting} variant='contained'>
            OK
          </Button>
        </DialogActions>
      </form>
    </Dialog>);
};
export default DialogInteracao;
